import styled from 'styled-components'

export const Container = styled.div`
    padding: 16px 32px;
    display: flex;
    gap: 8px;
    flex-direction: column;
`
